import * as React from 'react';
import DisciplinePage from '../../Components/DisciplinePage/DisciplinePage';
import Image from '../../img/sparring-page.webp';

const SECTIONS = [
  {
    heading: 'Principi e tecniche dello sparring',
    body: "Le sessioni di sparring variano da esercizi leggeri e controllati a sessioni più intense, adatte a praticanti di vari livelli di esperienza. Durante lo sparring, i combattenti apprendono l'importanza della distanza, del movimento e della strategia, oltre a migliorare la difesa e l'attacco. L'istruttore monitora e guida i praticanti, assicurando che le tecniche vengano eseguite correttamente e in sicurezza, enfatizzando il rispetto reciproco e il controllo.",
  },
  {
    heading: 'Lo sparring come strumento di crescita',
    body: "Nella Muay Thai, lo sparring è un'opportunità per crescita personale e apprendimento. Attraverso la pratica dello sparring, i praticanti sviluppano non solo la loro tecnica, ma anche la loro capacità di leggere l'avversario e adattarsi rapidamente a situazioni dinamiche. Lo sparring insegna a mantenere la calma sotto pressione, migliorando la resilienza mentale e la presenza di spirito. Questo tipo di allenamento aiuta i combattenti a guadagnare fiducia nelle proprie capacità e a sviluppare un profondo rispetto per l'arte marziale e per i loro avversari.",
  },
];

export default function SparringPage() {
  return (
    <DisciplinePage
      kicker="Attività 03"
      title="SPARRING"
      intro="Lo sparring è una componente vitale dell'allenamento in Muay Thai, fondamentale per sviluppare riflessi, tempismo e comprensione pratica delle tecniche di combattimento. Consente ai combattenti di testare e affinare le loro abilità in un contesto controllato e sicuro."
      sections={SECTIONS}
      image={Image}
    />
  );
}
